import axiosPrivate from "@services/axiosPrivate"
import { CREATE_CALENDAR_EVENT } from "src/constants"

export const createGoogleEvent = (data) =>
  axiosPrivate.post(CREATE_CALENDAR_EVENT, data, { withCredentials: true })
